<template>
  <div class="table-page-search-wrapper">
    <a-form layout="inline">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="5" :sm="24">
            <a-form-item label="付款编号">
              <a-input placeholder="请输入付款编号" v-model="searchModel.payNo" />
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="合同名称">
              <a-input placeholder="请输入合同名称" v-model="searchModel.contractName" />
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="收款公司">
              <a-select
                :allowClear="true"
                v-model="searchModel.companyId"
                showSearch
                optionFilterProp="children"
                placeholder="请选择收款公司"
              >
                <a-select-option v-for="(item, index) in companyList" :value="item.id" :key="index">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="付款类型">
              <a-select
                :allowClear="true"
                v-model="searchModel.payType"
                showSearch
                optionFilterProp="children"
                placeholder="请选择付款类型"
              >
                <a-select-option v-for="(item, index) in paymentType" :value="item.code" :key="index">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="search">查询</a-button>
              <a-button style="margin-left: 8px" @click="clearSearch">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </a-form>
  </div>
</template>

<script>
import { getDictInfoByCode } from '@/api/dict'
import { getProprietors, getSuppliers } from '@/api/business/invoice'

export default {
  name: 'MarketsSearchForm',
  mounted () {
    // 获取下拉框数据
    this.getDropdownListData()
  },
  computed: {
    projectList () {
      return this.$store.state.contract.projectList
    }
  },
  data () {
    return {
      showExpend: false,

      searchModel: {},
      advanced: false, // 是否展开
      // 付款类型
      paymentType: [],
      // 收款公司
      companyList: []
    }
  },
  methods: {
    // 获取下拉列表数据
    getDropdownListData () {
      // 获取收款类型数据
      getDictInfoByCode({ pCode: 'PAYMENT_TYPE' }).then(res => {
        this.paymentType = res.data
      })
      // 获取甲方名称列表
      getSuppliers({ paging: false }).then(res => {
        this.companyList = res.data
      })
    },
    // 搜索框展开
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 点击查询按钮
    search () {
      const model = this.searchModel
      if (model.payNo) {
        model.payNo = model.payNo.trim()
      }
      if (model.contractName) {
        model.contractName = model.contractName.trim()
      }
      for (var item in model) {
        if (!model[item]) {
          delete model[item]
        }
      }
      this.$emit('setSearchCondition', this.searchModel)
    },
    // 点击复位按钮
    clearSearch () {
      this.searchModel = {}

      this.$emit('clearSearch', this.searchModel)
    }
    // 获取select列表
  }
}
</script>

  <style scoped>
  </style>
